import { SeuConfigInputItem } from '@seu-types';

export type SeuOperatingConditionInputStream = {
  inputStreamId?: string;
  inputs: SeuConfigInputItem[];
};

export const SEU_OPERATING_CONDITION_CATEGORIES = [
  'WARRANTY',
  'PART_LOAD',
  'MAXIMUM_LOAD',
  'NOMINAL',
  'OTHER',
] as const;

export type SeuOperatingConditionCategory =
  (typeof SEU_OPERATING_CONDITION_CATEGORIES)[number];

export type SeuOperatingConditionBase = {
  title: string;
  description: string;
  categories?: SeuOperatingConditionCategory[];
  inputStreams: SeuOperatingConditionInputStream[];
  active: boolean;
};

export type SeuOperatingCondition = SeuOperatingConditionBase & {
  id: string;
  inputStreams: SeuOperatingConditionInputStream[];
};

type SeuOperatingConditionInputStreamApi = {
  inputStreamId?: string;
  inputs: SeuConfigInputItem[];
};
export type SeuOperatingConditionBaseApi = {
  title: string;
  description: string;
  categories: SeuOperatingConditionCategory[];
  inputStreams: SeuOperatingConditionInputStreamApi[];
  active: boolean;
};

export type SeuOperatingConditionApi = SeuOperatingConditionBaseApi & {
  id: number;
};
